import * as React from "react";
import { useEffect, useState } from "react";
import T from "../components/T/T";
import Layout from "../components/Layout/Layout";
import ClaimReward from "../components/ClaimReward/ClaimReward";
import CpaCarousel from "../components/CpaCarousel/CpaCarousel";
import CpaOffers from "../components/CpaOffers/CpaOffers";
import { getLocalQueryParams, getQueryParams } from "../lib/Misc";
import ProductPassport from "../components/ProductPassport/ProductPassport";
import PagePreload from "../components/PagePreload/PagePreload";

export default function Cpa() {
    const [loadingPageDisplay, setLoadingPageDisplay] = useState(true);
    const [selectedDisplay, setSelectedDisplay] = useState(null);
    const [showReward, setShowReward] = useState(false);
    const [registerData, setRegisterData] = useState([]);

    const queryParams = getQueryParams();
    if (typeof localStorage !== "undefined" && queryParams && !!queryParams.code && !!queryParams.clickId) {
        if (getLocalQueryParams().code !== queryParams.code || getLocalQueryParams().clickId !== queryParams.clickId) {
            localStorage.removeItem("registerData")
        }
        localStorage.setItem("queryParams", JSON.stringify(queryParams));
    }
    
    // Hide if there are no query params
    useEffect(() => {
        const localParams = getLocalQueryParams();
        const urlParams = getQueryParams() || {};
        if (!!localParams.clickId && (urlParams.clickId !== localParams.clickId)) {
            localStorage.setItem("selecteddisplay", null);
            setSelectedDisplay(null);
        } else {
            setSelectedDisplay(localStorage.getItem("selecteddisplay") || null);
        }
        setRegisterData(JSON.parse(localStorage.getItem("registerData")));
        setLoadingPageDisplay(false)
    }, []);

    const selectDisplayAction = (action) => {
        if (typeof localStorage !== "undefined") {
            localStorage.setItem("selecteddisplay", action);
            setSelectedDisplay(action)
        }
    }

    const checkQueryParams = !Object.values(queryParams).every(item => !item);

    return (
        <>
            <title>{selectedDisplay !== 'passport' ? (<T>title-qr</T>) : 'Product Passport'}</title>

            {!loadingPageDisplay && (
                <Layout
                    noHeaderSpace={true}
                    hideHeader={selectedDisplay === null}
                    selectedDisplay={selectedDisplay}
                    extraMainClass={showReward ? 'landing-rewards' : ''}
                >
                    {selectedDisplay === null ? (
                        <PagePreload
                            selectAction={(action) => {
                                setSelectedDisplay(action);
                            }}
                        />
                    ) : (
                        <>
                            <div className={`sub-nav tabulate-menu`}>
                                <div className={`tabulate-menu-item ${selectedDisplay !== 'passport' ? 'active' : ''}`}>
                                    <button
                                        onClick={() => {
                                            selectDisplayAction('gift')
                                        }}>
                                        Gift
                                    </button>
                                </div>
                                <div className={`tabulate-menu-item ${selectedDisplay === 'passport' ? 'active' : ''}`}>
                                    <button onClick={() => {
                                        selectDisplayAction('passport')
                                    }}>
                                        Product Passport
                                    </button>
                                </div>
                            </div>

                            {selectedDisplay !== 'passport' ?
                                <CpaCarousel
                                    selectedDisplay={selectedDisplay}
                                    showReward={!!registerData && !!registerData.rewards}
                                    showTitle={checkQueryParams}
                                />
                                : null
                            }

                            <div className="tabulate-page-wrapper">
                                <div className="tabulate-content">
                                    <div className={`tabulate-content-item ${selectedDisplay === null || selectedDisplay === 'gift' ? 'active' : ''}`}>
                                        <CpaOffers showReward={showReward} />
                                    </div>
                                    <div className={`tabulate-content-item ${selectedDisplay === 'passport' ? 'active' : ''}`}>
                                        <ProductPassport />
                                    </div>
                                </div>
                            </div>

                            {selectedDisplay !== 'passport' && checkQueryParams && (
                                <ClaimReward showReward={!!registerData && !!registerData.rewards} />
                            )}
                        </>)
                    }
                </Layout>
            )}
        </>
    );
}
